import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
const Loader = () => {
  const { t } = useTranslation("translation", { keyPrefix: "loader" });
  const [searchstr, setSearchstr] = useState("");
  const categoryName = useSelector((index) => index.categoryName);
  const subcategoryName = useSelector((index) => index.subcategoryName);
  const place = useSelector((index) => index.place);
  const searchBy = useSelector((index) => index.searchBy);
  const keyword = useSelector((index) => index.keyword);
  const isDisplayloder = useSelector((index) => index.isDisplayloder);
  useEffect(() => {
    if (searchBy === "topic")
      setSearchstr(t("searching_for") +" "+ categoryName +" "+ t("in"));
    else setSearchstr(t("searching_for") +" "+ keyword +" "+ t("in"));
  }, []);
  useEffect(()=>{
    // Window scrolled to top when component destroyed.
      window.scrollTo(0,0)
  },[])
  return <Fragment><h2>{isDisplayloder}</h2>{isDisplayloder && <Fragment>
  <section className="ram-loading">
    <div className="loading loading-text text-center">
      <h2>{t("title")}</h2>
      <img
        src="/wp-content/mu-plugins/resources-around-me//assets/images/spinner.png"
        alt=""
        aria-hidden="true"
      />
      <p>
        {searchstr}
        <br aria-hidden="true" />{" "}
        <strong>{place.formatted_address}</strong>
      </p>
    </div>
  </section>
</Fragment>}</Fragment>
  
   
  
};
export default Loader;
